import React from "react";
import { useAuth } from "../contexts/AuthContext";

const About: React.FC = () => {
    const { firebaseUser } = useAuth();

    return (
        <div className="min-h-screen bg-white">
            <div className="max-w-7xl mx-auto py-16 px-4 sm:px-6 lg:px-8">
                <div className="text-center">
                    <h1 className="text-4xl font-extrabold text-gray-900 sm:text-5xl">
                        About MealPlan
                    </h1>
                    <p className="mt-4 text-xl text-gray-600">
                        Simplifying meal planning for healthier living
                    </p>
                </div>

                <div className="mt-16">
                    <div className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-3">
                        {/* Mission */}
                        <div className="bg-gray-50 p-8 rounded-lg">
                            <div className="text-primary-500 text-4xl mb-4">
                                🎯
                            </div>
                            <h3 className="text-lg font-semibold text-gray-900 mb-3">
                                Our Mission
                            </h3>
                            <p className="text-gray-600">
                                To make healthy eating accessible and enjoyable
                                by providing personalized meal planning tools
                                that fit your lifestyle and dietary needs.
                            </p>
                        </div>

                        {/* Technology */}
                        <div className="bg-gray-50 p-8 rounded-lg">
                            <div className="text-primary-500 text-4xl mb-4">
                                🤖
                            </div>
                            <h3 className="text-lg font-semibold text-gray-900 mb-3">
                                AI-Powered Precision
                            </h3>
                            <p className="text-gray-600">
                                Experience the next generation of meal planning with cutting-edge AI models and finely tuned custom functions. Our platform delivers highly accurate, personalized meal plans, smart food suggestions, and a searchable food database—making healthy eating effortless and enjoyable.
                            </p>
                        </div>

                        {/* Community */}
                        <div className="bg-gray-50 p-8 rounded-lg">
                            <div className="text-primary-500 text-4xl mb-4">
                                👥
                            </div>
                            <h3 className="text-lg font-semibold text-gray-900 mb-3">
                                Community Driven
                            </h3>
                            <p className="text-gray-600">
                                Join thousands of users who are transforming
                                their relationship with food through better
                                planning and nutrition awareness.
                            </p>
                        </div>
                    </div>
                </div>

                <div className="mt-16 bg-primary-50 rounded-lg p-8">
                    <div className="text-center">
                        <h2 className="text-2xl font-bold text-gray-900 mb-4">
                            {firebaseUser 
                                ? "Continue your meal planning journey!" 
                                : "Ready to start your meal planning journey?"
                            }
                        </h2>
                        <p className="text-gray-600 mb-6">
                            {firebaseUser
                                ? "Access your personalized meal plans and continue planning healthy meals."
                                : "Join thousands of users who have simplified their meal planning with our platform."
                            }
                        </p>
                        <div className="space-x-4">
                            {firebaseUser ? (
                                <a
                                    href="/"
                                    className="inline-flex items-center px-6 py-3 border border-transparent text-base font-medium rounded-md text-white bg-primary-600 hover:bg-primary-700"
                                >
                                    Go to Meal Planner
                                </a>
                            ) : (
                                <>
                                    <a
                                        href="/signup"
                                        className="inline-flex items-center px-6 py-3 border border-transparent text-base font-medium rounded-md text-white bg-primary-600 hover:bg-primary-700"
                                    >
                                        Get Started
                                    </a>
                                    <a
                                        href="/signin"
                                        className="inline-flex items-center px-6 py-3 border border-gray-300 text-base font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50"
                                    >
                                        Sign In
                                    </a>
                                </>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default About;
